import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import QuestionOptions from './QuestionOptions';

const QuestionPanel = ({
  question,
  currentQuestionIndex,
  savedbackup,
  markedbackup,
  selectedAnswer,
  onAnswerChange,
}) => {
  if (!question) {
    return (
      <div className="empty-question-state">
        <div className="empty-question-state__icon">?</div>
        <h3>Select a section to begin</h3>
        <p>Choose a section above to load its questions.</p>
      </div>
    );
  }

  return (
    <section className="question-card" aria-label="Current question">
      <div className="question-card__meta">
        <span className="question-number">Question {currentQuestionIndex + 1}</span>
        {question.year && <span className="question-year">{ReactHtmlParser(question.year)}</span>}
      </div>

      <div className="question-card__body">
        <div className="question-text">{ReactHtmlParser(question.question || '')}</div>
        <div className="question-hint">Select one answer</div>
        <QuestionOptions
          question={question}
          savedbackup={savedbackup}
          markedbackup={markedbackup}
          selectedAnswer={selectedAnswer}
          onChange={onAnswerChange}
        />
      </div>
    </section>
  );
};

export default QuestionPanel;
